<template>
    <!-- START FILTER BLOCK -->
    <div class="vx-col w-full mb-base">
      <div class="filter_container">
        <!-- DATE FILTER BLOCK -->
        <vx-card title="Filtrer les données">
          <p>
            Sélectionner la période pour laquelle vous souhaitez filtrer vos
            données
          </p>

          <div class="vx-row">
            <div class="vx-row comparing_div">
              <div class="vx-col">
                <div class="mt-4">
                  <flat-pickr
                    :config="configFromDatePicker"
                    v-model="fromDate"
                    placeholder="Depuis le"
                  />
                </div>
                <div class="mt-4 mb-4">
                  <flat-pickr
                    :config="configToDatePicker"
                    v-model="toDate"
                    placeholder="Jusqu'au"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="vx-row comparing_div">
              <div>
                <vs-button color="primary" class="float-left" @click="displayOptions"
                  >Options de comparaisons</vs-button
                >
              </div>
            </div>
            <div class="vx-row comparing_container"> -->
              <!--ICI-->
              <!-- <div class="vx-row comparing_div">
                <div class="vx-col">
                  <div class="mt-4">
                    <flat-pickr
                      :config="configFromDatePicker"
                      v-model="compareFromDate"
                      placeholder="Depuis le "
                    />
                  </div>
                  <div class="mt-4 mb-4">
                    <flat-pickr
                      :config="configToDatePicker"
                      v-model="compareToDate"
                      placeholder="Jusqu'au"
                    />
                  </div>
                </div>
              </div>
              <div class="vx-row comparing_div">
                <div>
                  <p>Ou</p>
                </div>
              </div>
              <div class="vx-row comparing_div">
                <ul>
                  <li>
                    <vs-checkbox v-model="oneYearAgo">Il y a un an</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="sixMonthsAgo"
                      >Il y a 6 mois</vs-checkbox
                    >
                  </li>
                </ul>
              </div>
              <div class="vx-row comparing_div"> -->
                <!-- <vs-button color="primary" class="float-left" @click="resetFilter"> -->
                    <!-- Réinitialiser le filtre -->
                <!-- </vs-button> -->
              <!-- </div>

            </div> -->

          </div>
          <div class="vx-row float-right">
                    <vs-button color="primary" class="float-left" @click="saveDates">
                      Enregistrer
                    </vs-button>
                </div>
        </vx-card>
      </div>
    </div>
    <!-- END FILTER BLOCK -->
</template>
<script>
import utilsMixin from "@/mixins/utilsMixin";

import flatPickr from "vue-flatpickr-component";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "flatpickr/dist/flatpickr.css";

export default {
	name: "DateFilter",
	components: {
		flatPickr
	},
	mixins: [utilsMixin],
	data() {
		return {
			// DATE PICKER DATA
			fromDate: this.getDateToFrenchFormatFourDigit(new Date(Date.now())),
			toDate: this.getDateToFrenchFormatFourDigit(new Date(Date.now())),
			compareFromDate: null,
			compareFromDateShow: null,
			compareToDate: null,
			compareToDateShow: null,
			configFromDatePicker: {
				maxDate: new Date(),
				dateFormat: "d/m/Y"
			},
			configToDatePicker: {
				maxDate: new Date(Date.now()),
				dateFormat: "d/m/Y"
			},
			today: new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate()
			)
				.toISOString()
				.slice(0, 10),
			oneYearAgo: false,
			sixMonthsAgo: false,
		};
	},
	created() {
		// this.getLastMonthYearFromToDate()
		this.getLastYearFromToDate();
		this.initStatDateFilter();
	},
	methods: {
		/**
		 * Once called, display the comparison option available
		 */
		displayOptions() {
			let container = document.getElementsByClassName("comparing_container");
			if(container[0].style.display == "") {
				container[0].style.display = "flex";
			}
			else{
				container[0].style.display = "";
			}
		},
		getLastMonthFromToDate(){
			let today = new Date(Date.now());
			let year = today.getMonth() - 1 < 0 ? today.getFullYear() - 1 : today.getFullYear();
			let month = today.getMonth();
			let day = today.getDate();
			this.fromDate = this.getDateToFrenchFormatFourDigit(new Date(year, month - 1, 1));
			this.toDate = this.getDateToFrenchFormatFourDigit(new Date(year, month, 0));
		},

		getLastYearFromToDate(){
			let today = new Date(Date.now());
			let year = today.getFullYear();
			let month = today.getMonth();
			let day = today.getDate();
			this.fromDate = this.getDateToFrenchFormatFourDigit(new Date(year-1, month, 1));
			this.toDate = this.getDateToFrenchFormatFourDigit(new Date(year, month, day));
			//console.log("getLastYearFromToDate", this.toDate, year, month, day, today);
		},

		getLastMonthYearFromToDate(){
			let today = new Date(Date.now());
			let year = today.getMonth() - 1 < 0 ? today.getFullYear() - 1 : today.getFullYear();
			let month = today.getMonth();
			let day = today.getDate();
			this.fromDate = this.getDateToFrenchFormatFourDigit(new Date(year - 1, month - 1, 1));
			this.toDate = this.getDateToFrenchFormatFourDigit(new Date(year, month - 1, 1));
		},

		initStatDateFilter(){
			let dateFilter = {
				fromDate: this.fromDate !== null ? this.fromDate.split("/").reverse().join("-") : null,
				toDate: this.toDate !== null ? this.toDate.split("/").reverse().join("-") : null,
				compareFromDate: this.compareFromDate !== null ? this.compareFromDate.split("/").reverse().join("-") : null,
				compareFromDateShow: this.compareFromDateShow !== null ? this.compareFromDateShow.split("/").reverse().join("-") : null,
				compareToDate: this.compareToDate !== null ? this.compareToDate.split("/").reverse().join("-") : null,
				compareToDateShow: this.compareToDateShow !== null ? this.compareToDateShow.split("/").reverse().join("-") : null,
				oneYearAgo: this.oneYearAgo,
				sixMonthsAgo: this.sixMonthsAgo,
			};
			//console.log("initStatDateFilter toDate", this.toDate);
			this.$store.commit("SET_STAT_DATE_FILTER", dateFilter);
		},
		saveDates(){
			let dateFilter = {
				fromDate: this.fromDate !== null ? this.fromDate.split("/").reverse().join("-") : null,
				toDate: this.toDate !== null ? this.toDate.split("/").reverse().join("-") : null,
				compareFromDate: this.compareFromDate !== null ? this.compareFromDate.split("/").reverse().join("-") : null,
				compareFromDateShow: this.compareFromDateShow !== null ? this.compareFromDateShow.split("/").reverse().join("-") : null,
				compareToDate: this.compareToDate !== null ? this.compareToDate.split("/").reverse().join("-") : null,
				compareToDateShow: this.compareToDateShow !== null ? this.compareToDateShow.split("/").reverse().join("-") : null,
				oneYearAgo: this.oneYearAgo,
				sixMonthsAgo: this.sixMonthsAgo,
			};
			this.$store.commit("SET_STAT_DATE_FILTER", dateFilter);
			this.$emit("close-form", false);
			//console.log("saveDates");
		}
	},
};
</script>
<style lang="scss" scoped>
.comparing_div {
  margin: 5px;
  align-items: center;
}
.comparing_container {
  display: none;
  margin: 5px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}
</style>